var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeedbackNeut(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99989 0C3.58876 0 0 3.5888 0 7.99999C0 12.4112 3.58876 16 7.99989 16C12.411 16 15.9998 12.4112 15.9998 7.99999C15.9998 3.5888 12.4111 0 7.99989 0Z",
    fill: "#FF9800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6845 10.7567H5.27905V11.6216H10.6845V10.7567Z",
    fill: "#413E34"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.21594 7.95296C5.45324 7.95296 5.66805 7.85722 5.82432 7.70247C5.98264 7.54576 6.0808 7.32841 6.0808 7.08808C6.0808 6.61045 5.69356 6.22321 5.21594 6.22321C4.73832 6.22321 4.35107 6.61045 4.35107 7.08808C4.35107 7.20046 4.37318 7.30749 4.41221 7.40603C4.53902 7.7262 4.8507 7.95296 5.21594 7.95296Z",
    fill: "#413E34"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3712 7.40603C11.4103 7.30754 11.4324 7.20046 11.4324 7.08808C11.4324 6.61045 11.0451 6.22321 10.5675 6.22321C10.0899 6.22321 9.70264 6.61045 9.70264 7.08808C9.70264 7.32841 9.8008 7.54576 9.95912 7.70252C10.1154 7.85722 10.3302 7.95296 10.5675 7.95296C10.9327 7.95296 11.2444 7.7262 11.3712 7.40603Z",
    fill: "#413E34"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackNeut);
export default __webpack_public_path__ + "static/media/feedback-neut.df7254b92fd8c26aee64511ae693da0d.svg";
export { ForwardRef as ReactComponent };